<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">     
        <div class="u-window m-share-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper">
                <div class="dialog-body">
                    <h6 class="title"></h6>
                    <div class="share-text" v-html="shareTxt"></div>
                </div>

                <button class="u-btn copy" data-clipboard-action="copy" :data-clipboard-text="shareTxt" @click="copy"></button>      
            </div>         
        </div>
      
        <div class="u-mask"></div>
    </div>
</transition>      
</template>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            text : '分享成功后，获得分享礼*1！<br>如果有朋友通过你的分享首次进入页面，<br>双方还可获得互助礼*1！快去分享给好友吧！',
            shareTxt : '十五周年预热活动正式开启，每日分享可获得分享宝箱，点击“复制链接”进行分享！',
            gid : '',
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
        this.$disableScroll();
    },
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$enableScroll();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },    
        copy() {
            //复制链接
            let _this = this;
            let clipboard = new _this.clipboard(".copy");
            clipboard.on('success', function () {
              clipboard.destroy();
              _this.destroyElement();
              _this.$toast("链接复制成功，快去分享给好友吧！");
              
              _this.success = true;
            });
            clipboard.on('error', function () {
              _this.$toast("复制失败");
            });
            //_this.destroyElement();
        },      
    },
}
</script>

<style lang="scss" scoped>
/* share */
.m-share-modal {
    width: 590px;
    height: 409px;
    background-image: url(~@/assets/images/modal/bg-modal-share.png);
}

.m-share-modal h6 {
    width: 378px;
    height: 43px;
    margin: 0 auto 35px;
    background-image: url(~@/assets/images/modal/title-share.png);
}

.m-share-modal .share-text {
    padding: 0 30px;
    word-break: break-all;
    line-height: 1.6;
    color: #f8e1dc;
    text-align: center;
}

.m-share-modal .u-btn.copy {
    position: absolute;
    left: 50%;
    bottom: 40px;
    width: 236px;
    height: 60px;
    margin-left: -118px;
    background-image: url(~@/assets/images/modal/btn-copy.png);
}

</style>